import React from "react";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";

// Image paths (adjust if needed)
const service1 = "./assets/service7.png";
const service2 = "./assets/service13.png";
const service3 = "./assets/service18.png";
const service4 = "./assets/service5.png";
const service5 = "./assets/service2.png";
const service6 = "./assets/service10.png";
const service7 = "./assets/service17.png";
const service8 = "./assets/service12.png";
const service9 = "./assets/service11.png";

const services = [
  {
    title: "Prescribing for Minor Conditions",
    description:
      "Our pharmacist can prescribe for minor health conditions like acid reflux, UTIs, allergies, and more.",
    route: "/consultation",
    image: service1,
  },
  {
    title: "Vaccines & Immunizations",
    description:
      "Get vaccinated at the pharmacy—skip the doctor's office wait and protect your health.",
    route: "/vaccination",
    image: service2,
  },
  {
    title: "Virtual Travel Clinic & Travel Vaccines",
    description:
      "Book a virtual consultation and get all your travel vaccines, including yellow fever.",
    route: "/vaccination",
    image: service3,
  },
  {
    title: "Compounding",
    description:
      "We offer custom medication formulations that aren’t available as commercial products.",
    route: "/about#compounding",
    image: service4,
  },
  {
    title: "Compliance Aids",
    description:
      "Never forget your medications with our free blister pack service to help you stay on track.",
    route: "/about#compliance-aids",
    image: service5,
  },
  {
    title: "Full Medication Reviews",
    description:
      "Receive a comprehensive review of your medications to ensure optimal treatment and management.",
    route: "/about#medication-review",
    image: service6,
  },
  {
    title: "Medications Delivery",
    description:
      "We understand mobility can be challenging. Let us deliver your medications straight to your door.",
    route: "/about#medications-delivery",
    image: service7,
  },
  {
    title: "Refill Reminders",
    description:
      "Never miss a dose with our automatic reminders when it's time to refill your prescriptions.",
    route: "/about#refill-reminders",
    image: service8,
  },
  {
    title: "Easy Rx Transfer",
    description:
      "Transfer your prescriptions easily with our efficient, hassle-free service.",
    route: "/transfers",
    image: service9,
  },
];

export default function QuickAccessServices() {
  const navigate = useNavigate();
  const { width } = useWindowDimensions();

  // Determine the number of columns based on the window width.
  // Tailwind breakpoints: <640 = 1, 640-767 = 2, >=768 = 3.
  let columns = 1;
  if (width >= 768) {
    columns = 3;
  } else if (width >= 640) {
    columns = 2;
  }

  const totalServices = services.length;
  const numRows = Math.ceil(totalServices / columns);

  return (
    <div className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-5xl font-bold text-gray-900 mb-12 mt-8 text-center">
          Our Services
        </h2>
        {/* Grid with no gap so cells touch */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-0">
          {services.map((service, index) => {
            // Determine if this card is in the last column
            const isLastColumn = index % columns === columns - 1;
            // Determine the current row number (0-indexed)
            const currentRow = Math.floor(index / columns);
            // Check if it's the last row
            const isLastRow = currentRow === numRows - 1;

            return (
              <div
                key={index}
                onClick={() => navigate(service.route)}
                className={`bg-white hover:shadow-2xl hover:bg-gray-100 transition-shadow duration-300 p-4 cursor-pointer flex flex-col items-center
                  ${!isLastColumn ? "border-r border-[#d2b48c]" : ""} 
                  ${!isLastRow ? "border-b border-[#d2b48c]" : ""}`}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-20 h-20 object-contain mb-4"
                />
                <h3 className="text-xl font-semibold text-gray-900 text-center">
                  {service.title}
                </h3>
                <p className="mt-2 text-gray-600 text-center text-sm">
                  {service.description}
                </p>
                <div className="mt-4">
                  {[1, 5, 8].includes(index) && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        navigate(service.route);
                      }}
                      className="bg-[#f49988] text-white text-sm py-2 px-4 rounded-2xl hover:bg-[#d17564] mb-3"
                    >
                      Learn More
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
